import { render, staticRenderFns } from "./ReviewOpinionResult.vue?vue&type=template&id=30e15a88&scoped=true"
import script from "./ReviewOpinionResult.vue?vue&type=script&lang=js"
export * from "./ReviewOpinionResult.vue?vue&type=script&lang=js"
import style0 from "./ReviewOpinionResult.vue?vue&type=style&index=0&id=30e15a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e15a88",
  null
  
)

export default component.exports